import { render, staticRenderFns } from "./SearchBreadcrumbs.vue?vue&type=template&id=121538da&scoped=true"
import script from "./SearchBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./SearchBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./SearchBreadcrumbs.vue?vue&type=style&index=0&id=121538da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121538da",
  null
  
)

export default component.exports